import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FastForwardIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.0432 12.54C11.2052 12.4189 11.3367 12.2619 11.4273 12.0814C11.5178 11.9009 11.565 11.7018 11.565 11.5C11.565 11.2982 11.5178 11.0991 11.4273 10.9186C11.3367 10.7381 11.2052 10.5811 11.0432 10.46L4.087 5.26C3.89321 5.11514 3.66278 5.02693 3.42152 5.00525C3.18026 4.98357 2.93771 5.02928 2.72104 5.13725C2.50438 5.24521 2.32216 5.41118 2.19481 5.61655C2.06746 5.82192 2 6.05857 2 6.3V16.7C2 16.9414 2.06746 17.1781 2.19481 17.3834C2.32216 17.5888 2.50438 17.7548 2.72104 17.8628C2.93771 17.9707 3.18026 18.0164 3.42152 17.9947C3.66278 17.9731 3.89321 17.8849 4.087 17.74L11.0432 12.54ZM21.4782 12.54C21.6402 12.4189 21.7717 12.2619 21.8623 12.0814C21.9529 11.9009 22 11.7018 22 11.5C22 11.2982 21.9529 11.0991 21.8623 10.9186C21.7717 10.7381 21.6402 10.5811 21.4782 10.46L14.522 5.26C14.3282 5.11514 14.0978 5.02693 13.8565 5.00525C13.6153 4.98357 13.3727 5.02928 13.1561 5.13725C12.9394 5.24521 12.7572 5.41118 12.6298 5.61655C12.5025 5.82192 12.435 6.05857 12.435 6.3V16.7C12.435 16.9414 12.5025 17.1781 12.6298 17.3834C12.7572 17.5888 12.9394 17.7548 13.1561 17.8628C13.3727 17.9707 13.6153 18.0164 13.8565 17.9947C14.0978 17.9731 14.3282 17.8849 14.522 17.74L21.4782 12.54Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

FastForwardIcon.displayName = 'FastForwardIcon';
